import { render, staticRenderFns } from "./PartyDetail.vue?vue&type=template&id=3e747b48"
import script from "./PartyDetail.vue?vue&type=script&lang=js"
export * from "./PartyDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports